/**
 * 表紙・特集商品選定依頼確認（グループ長用）画面の依頼先バイヤークラス
 *
 * @export RequestBuyer
 * @class RequestBuyer
 */
export class RequestBuyer {
  constructor(
    public requestBuyerUserId: string,
    public requestBuyerUserName: string,
  ) {}
}
